import React, { useEffect, useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import {
  Container,
  Typography,
  Input,
  Button,
  ErrorDialog,
} from "src/components";
import { useForm } from "react-hook-form";
import { IError } from "src/components/dialog/error";
import * as formValidators from "src/utils/form-validator";
import { localizationStrings } from "./constants";
import { hideKeyboard } from "src/utils/event";
import { Auth } from "aws-amplify";
import { CommonActions } from "@react-navigation/native";
import LocalText from "src/local";
import alert from "src/components/alert";
import { useNavigation, useRoute } from "@react-navigation/native";
import { RootStackScreenProps } from "src/navigation/types";

export type SignUpConfirmNavigationParam = {
  email: string;
};

type FormValues = {
  code: string;
};

export const AuthSignUpConfirmScreen: React.FC = () => {
  const navigation =
    useNavigation<RootStackScreenProps<"SignUpConfirm">["navigation"]>();
  const route = useRoute<RootStackScreenProps<"SignUpConfirm">["route"]>();
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { code: "" },
  });
  const [error, setError] = useState<IError | null>(null);
  const [processed, setProcessed] = useState<boolean>(false);
  useEffect(() => {
    register("code", {
      validate: (value) => {
        if (!formValidators.RequireValidator(value)) {
          return localizationStrings.inputCodeValidationRequire;
        }
        // TODO: Add code pattern
        return true;
      },
    });
  }, [register]);
  const onConfirm = async (data: FormValues) => {
    hideKeyboard();
    setProcessed(true);
    try {
      await Auth.confirmSignUp(route.params.email, data.code);
      alert(
        LocalText.screens.authSignupConfirm.confirmSuccessAlertTitle,
        LocalText.screens.authSignupConfirm.confirmSuccessAlertDescription,
        [
          {
            text: LocalText.common.ok,
            onPress: () => {
              navigation.dispatch(
                CommonActions.reset({
                  index: 1,
                  routes: [{ name: "Auth" }, { name: "SignIn" }],
                })
              );
            },
          },
        ],
        { cancelable: false }
      );
    } catch (e: any) {
      if (e.code === "CodeMismatchException") {
        const authError = new Error(
          LocalText.screens.authSignupConfirm.errorCodeMismatchException
        );
        console.error(authError);
        setError(authError);
      } else {
        console.error(e);
        setError(e as Error);
      }
      setProcessed(false);
    }
  };
  return (
    <Container style={styles.container} loading={processed}>
      <ScrollView>
        <Typography text={localizationStrings.label} variant={"section"} />
        <Input
          placeholder={localizationStrings.inputCodePlaceholder}
          name={"code"}
          control={control}
          error={errors.code?.message}
          keyboardType={"number-pad"}
          autoCapitalize={"none"}
        />
        <View style={styles.buttonContainer}>
          <Button
            title={localizationStrings.btnReset}
            loading={processed}
            onPress={handleSubmit(onConfirm)}
          />
        </View>
      </ScrollView>
      {error ? (
        <ErrorDialog
          error={error}
          visible={true}
          onClose={() => setError(null)}
        />
      ) : null}
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  buttonContainer: {
    flexDirection: "column",
    marginTop: 36,
    marginHorizontal: 16,
  },
});
